const APOSTROPHES = /[\u2018\u2019\u02bc\u0060\u00b4']/g;

export function normalizeContentText(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('fr-FR')
    .replace(APOSTROPHES, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function normalizedWords(value: string): string[] {
  const normalized = normalizeContentText(value);
  return normalized ? normalized.split(' ') : [];
}

export function stableId(...parts: Array<string | number>): string {
  const encoded = parts.map((part) => {
    const value = String(part);
    const type = typeof part === 'number' ? 'n' : 's';
    return `${type}${value.length}:${value}`;
  }).join('');

  return `v3_${encoded}`;
}

export function equivalenceKey(value: string): string {
  return `word_${normalizeContentText(value).replace(/\s+/g, '_')}`;
}
